"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardGalleryItem } from "./WaveLeaderboardGalleryItem";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
interface WaveLeaderboardGalleryProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardGallery: React.FC<WaveLeaderboardGalleryProps> = t0 => {
  const $ = _c(27);
  const {
    wave,
    sort,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== sort || $[1] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort
    };
    $[0] = sort;
    $[1] = wave.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  const [animationKey, setAnimationKey] = React.useState(0);
  const [previousSort, setPreviousSort] = React.useState(sort);
  let t2;
  let t3;
  if ($[3] !== previousSort || $[4] !== sort) {
    t2 = () => {
      if (previousSort !== sort) {
        setPreviousSort(sort);
        setAnimationKey(_temp);
      }
    };
    t3 = [sort, previousSort];
    $[3] = previousSort;
    $[4] = sort;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[7] !== drops) {
    t4 = drops.filter(_temp2) || [];
    $[7] = drops;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const dropsWithMedia = t4;
  if (isFetching && dropsWithMedia.length === 0) {
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center"><div className="tw-text-sm tw-text-iron-500">Loading drops...</div></div>;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  if (dropsWithMedia.length === 0) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center tw-text-sm tw-text-iron-500">No drops to show</div>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== animationKey || $[12] !== dropsWithMedia || $[13] !== onDropClick || $[14] !== sort) {
    let t6;
    if ($[16] !== animationKey || $[17] !== onDropClick || $[18] !== sort) {
      t6 = drop_0 => <WaveLeaderboardGalleryItem key={drop_0.id} drop={drop_0} onDropClick={onDropClick} activeSort={sort} animationKey={animationKey} />;
      $[16] = animationKey;
      $[17] = onDropClick;
      $[18] = sort;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t5 = dropsWithMedia.map(t6);
    $[11] = animationKey;
    $[12] = dropsWithMedia;
    $[13] = onDropClick;
    $[14] = sort;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[20] !== fetchNextPage || $[21] !== hasNextPage || $[22] !== isFetchingNextPage) {
    t6 = hasNextPage && <div className="tw-col-span-full tw-mb-2 tw-mt-4 tw-flex tw-justify-center"><button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900 tw-px-4 tw-py-2 tw-text-sm tw-text-iron-400 tw-transition desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{isFetchingNextPage ? "Loading more..." : "Load more drops"}</button></div>;
    $[20] = fetchNextPage;
    $[21] = hasNextPage;
    $[22] = isFetchingNextPage;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t5 || $[25] !== t6) {
    t7 = <div className="tw-@container"><div className="tw-grid tw-gap-x-4 tw-gap-y-8 @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3">{t5}{t6}</div></div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
function _temp(prev) {
  return prev + 1;
}
function _temp2(drop) {
  return (drop.parts[0]?.media.length ?? 0) > 0;
}